/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { MouseEventHandler, ReactNode, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ReactComponent as CloseIcon } from '../../assets/icons/closeIcon.svg';
import { ReactComponent as ExitIcon } from '../../assets/icons/exitIcon.svg';
import { ReactComponent as MediaIcon } from '../editor/editorFormattingIcons/mediaButton.svg';
import { ReactComponent as PreviewIcon } from '../editor/editorFormattingIcons/previewButton.svg';
import './modal.scss';

interface ModalComponentInterface {
  show: boolean;
  modalDetails: {
    title: string | JSX.Element;
    body: ReactNode;
  };
  backButton?: {
    disabled: boolean;
    label: string;
    handleBack: MouseEventHandler;
  };
  confirmButton?: {
    disabled: boolean;
    label: string;
    handleConfirm: MouseEventHandler;
  };
  cancelButton?: { label: string; handleCancel?: MouseEventHandler };
  handleCancel: MouseEventHandler;
  dialogClassName?: string;
  isCentered?: boolean;
  size?: 'sm' | 'lg' | 'xl' | undefined;
  modalType?: string;
}

const ModalComponent = (props: ModalComponentInterface) => {
  const {
    show,
    size,
    modalDetails,
    backButton,
    confirmButton,
    cancelButton,
    handleCancel,
    dialogClassName,
    isCentered,
    modalType,
  } = props;
  const { title, body } = modalDetails;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (dialogClassName === 'addordropmodal') {
      setIsModalOpen(true);
    } else {
      handleCancel(e);
    }
  };
  return (
    <>
      <Modal
        id='lint-custom-modal'
        size={size}
        show={show}
        aria-labelledby='confirmation-popup'
        centered={isCentered ?? true}
        className='lint-custom-modal'
        backdrop='static'
        dialogClassName={dialogClassName ? dialogClassName : ''}
      >
        <Modal.Header className='pb-2 justify-content-between '>
          <Modal.Title
            id='lint-custom-modal'
            className='d-flex align-items-center gap-2 d-flex justify-content-between'
            tabIndex={0}
          >
            {props?.modalDetails?.title === 'Media' && (
              <div className='icon-background-container'>
                <MediaIcon />
              </div>
            )}
            {props?.modalDetails?.title === 'Preview' && (
              <div className='icon-background-container'>
                <PreviewIcon />
              </div>
            )}
            {title}
          </Modal.Title>
          {modalType === 'preview' || modalType === 'previewHotSpot' ? (
            <Button className='exit-preview-btn' onClick={handleCancel}>
              <CloseIcon />
            </Button>
          ) : (
            <div
              id='lint-custom-modal-close-icon'
              tabIndex={0}
              role='button'
              className='media-close-icon'
              onClick={handleOpenModal}
              onKeyDown={(event) => {
                if (event.key === ' ' || event.key === 'Enter') {
                  event.preventDefault();
                  handleOpenModal(event as any);
                }
              }}
            >
              <CloseIcon />
            </div>
          )}
        </Modal.Header>
        <Modal.Body
          className={`preview-modal-class ${modalType === 'preview' ? 'preview-modal-body' : ''} ${
            props?.modalDetails?.title === 'Media' ? 'media-modal-body' : ''
          }`}
          tabIndex={0}
        >
          <div className='preview-modal-content-Wrapper'>{body}</div>
        </Modal.Body>
        {(backButton ?? confirmButton ?? cancelButton) && (
          <Modal.Footer className='justify-content-center model-footer-element'>
            {backButton && (
              <button
                type='button'
                id={`lint-custom-modal-${backButton.label}-button`}
                className='btn btn-outline-primary editor-custom-cancel-button'
                disabled={backButton.disabled}
                onClick={backButton.handleBack}
              >
                {backButton.label}
              </button>
            )}
            {cancelButton && (
              <button
                type='button'
                id={`lint-custom-modal-${cancelButton.label}-button`}
                className='btn btn-outline-primary editor-custom-cancel-button'
                onClick={(e) => {
                  if (dialogClassName === 'addordropmodal') {
                    setIsModalOpen(true);
                  } else {
                    cancelButton.handleCancel ? cancelButton.handleCancel(e) : handleCancel(e);
                  }
                }}
              >
                {cancelButton.label}
              </button>
            )}
            {confirmButton && (
              <button
                type='button'
                id={`lint-custom-modal-${confirmButton.label}-button`}
                className={`editor-btn-primary editor-custom-button btn btn-primary  ${
                  confirmButton.label === 'Delete' ? 'delete-button' : ''
                }`}
                disabled={confirmButton.disabled}
                onClick={confirmButton.handleConfirm}
              >
                {confirmButton.label}
              </button>
            )}
          </Modal.Footer>
        )}
      </Modal>
      {isModalOpen && (
        <div className='modal show fade subModal' tabIndex={-1}>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header justify-content-between'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <ExitIcon />
                  <span
                    style={{
                      color: ' #585858',
                      fontWeight: 400,
                      fontSize: '16px',
                      fontFamily: 'Lexend',
                    }}
                  >
                    Exit Interactive
                  </span>
                </div>{' '}
                <button
                  type='button'
                  aria-label='Close'
                  className='closeIcon'
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                >
                  <CloseIcon />
                </button>
              </div>

              <div className='modal-body'>
                Are you sure want to exit? Changes you made will not be saved.
              </div>

              <div className='modal-footer d-flex justify-content-center'>
                <button
                  type='button'
                  id='lint-submodal-custom-modal-Cancel-button'
                  className='btn btn-outline-primary editor-submodal-custom-cancel-button'
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  id='lint-submodal-custom-modal-Exit-button'
                  className='editor-btn-primary editor-submodal-custom-button btn btn-primary  '
                  onClick={(e) => {
                    setIsModalOpen(false);
                    handleCancel(e);
                  }}
                >
                  Exit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalComponent;
